import React from "react";
import { Archive, FileSpreadsheet, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// Toolbar shown when one or more orders are checked in the table — bulk export/reminder/status actions.
export const BulkActionsToolbar = ({ selectedIds, onZip, onCsv, onRemind, onBulkStatus, onClear }) => {
  if (selectedIds.length === 0) return null;
  return (
    <div className="flex items-center gap-2 mb-3 flex-wrap rounded-lg border border-border bg-[#F7F0E6] px-3 py-2" data-testid="bulk-toolbar">
      <span className="text-sm font-medium mr-2">{selectedIds.length} selected</span>
      <Button size="sm" variant="outline" className="gap-1.5" onClick={onZip}><Archive className="h-3.5 w-3.5" /> Download Invoices</Button>
      <Button size="sm" variant="outline" className="gap-1.5" onClick={onCsv}><FileSpreadsheet className="h-3.5 w-3.5" /> Export CSV</Button>
      <Button size="sm" variant="outline" className="gap-1.5" onClick={onRemind}><Send className="h-3.5 w-3.5" /> Send Reminders</Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild><Button size="sm" variant="outline">Update Status</Button></DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={() => onBulkStatus("approve")}>Approve</DropdownMenuItem>
          <DropdownMenuItem onClick={() => onBulkStatus("process")}>Move to Processing</DropdownMenuItem>
          <DropdownMenuItem onClick={() => onBulkStatus("ship")}>Mark Shipped</DropdownMenuItem>
          <DropdownMenuItem onClick={() => onBulkStatus("complete")}>Mark Completed</DropdownMenuItem>
          <DropdownMenuItem onClick={() => onBulkStatus("cancel")} className="text-destructive">Cancel</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Button size="sm" variant="ghost" className="ml-auto" onClick={onClear}>Clear</Button>
    </div>
  );
};
